<div class="container-details">
  <div class="back-button" nz-col nzSpan="24" [routerLink]="backLink">
    <span nz-icon nzType="arrow-left" nzTheme="outline"></span>
    {{ starterString + '.back' | translate }}
  </div>
  <div class="header">
    <i></i>
    <p class="title">{{ starterString + '.title' | translate }}</p>
  </div>
  <div class="content">
    @for (answer of answers; track answer) {
      <div>
        <p class="answer">{{ answer.answer }}</p>
        <p class="question">{{ answer.question }}</p>
        @if (answer.subtext) {
          <i class="subtext margin">{{ answer.subtext }}</i>
        }
      </div>
    }
    @if (starterString === 'faqFasdac') {
      <i class="subtext">{{ starterString + '.subText' | translate }}</i>
    }
  </div>
</div>
